import Axios from "axios";
import {
    SET_CS_QUOTATION_LIST,
    UNSET_CS_QUOTATION_LIST,
    SET_SELECTED_CS_QUOTATION_LIST,
    UNSET_SELECTED_CS_QUOTATION_LIST,
    SET_SELECTED_CS_QUOTATION_EVALUATION_LIST,
    UNSET_SELECTED_CS_QUOTATION_EVALUATION_LIST,
  } from "@/store/mutation-types";
import {
  saveUpdateCsQuotation,
  getCsQuotationList, 
  getCsQuotationById as getCsQuotationByIdApi,
  getSelectedCsQuotationList,
  getSelectedCsQuotationEvaluationList,
  getCsEvaluationById as getCsEvaluationByIdApi,
} from "@/store/api";
// initial state
const state = {
  getCsQuotationList: [],
  getSelectedCsQuotationEvaluationList: [],
  getSelectedCsQuotationList: [],
  editingCsQuotation: null,
};

const getters = {
  getCsQuotationList(state) {
    return state.getCsQuotationList;
  },
  getSelectedCsQuotationEvaluationList(state) {
    return state.getSelectedCsQuotationEvaluationList;
  },
  getSelectedCsQuotationList(state) {
    return state.getSelectedCsQuotationList;
  },
  getEditingCsQuotation: (state) => { 
    return state.editingCsQuotation;
  },
};

const mutations = {
  [SET_SELECTED_CS_QUOTATION_EVALUATION_LIST](state, data) {
    state.getSelectedCsQuotationEvaluationList = data;
  },
  [UNSET_SELECTED_CS_QUOTATION_EVALUATION_LIST](state) {
    state.getSelectedCsQuotationEvaluationList = [];
  },
  [SET_SELECTED_CS_QUOTATION_LIST](state, data) {
    state.getSelectedCsQuotationList = data;
  },
  [UNSET_SELECTED_CS_QUOTATION_LIST](state) {
    state.getSelectedCsQuotationList = [];
  },
  [SET_CS_QUOTATION_LIST](state, data) {
    state.getCsQuotationList = data;
  },
  [UNSET_CS_QUOTATION_LIST](state) {
    state.getCsQuotationList = [];
  },
  setEditingCsQuotation(state, csQuotation) {
    state.editingCsQuotation = csQuotation;
  },
};

const actions = {
    getSelectedCsQuotationEvaluationList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getSelectedCsQuotationEvaluationList, { data })
        .then(function (response) {
          commit('SET_SELECTED_CS_QUOTATION_EVALUATION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SELECTED_CS_QUOTATION_EVALUATION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getSelectedCsQuotationList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getSelectedCsQuotationList, { data })
        .then(function (response) {
          commit('SET_SELECTED_CS_QUOTATION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SELECTED_CS_QUOTATION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdateCsQuotation({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCsQuotation, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCsQuotationList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCsQuotationList, data)
        .then(function (response) {
          commit('SET_CS_QUOTATION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CS_QUOTATION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getCsQuotationById({ commit }, id) {
    const getCsQuotationById = `${getCsQuotationByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getCsQuotationById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },


  getCsEvaluationById({ commit }, id) {
    const getCsEvaluationById = `${getCsEvaluationByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(getCsEvaluationById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },


  
};

export default {
  state,
  getters,
  actions,
  mutations,
};
